/**
 * Constants specific to the TimePicker component
 */

// Generate hour options (1-12)
export const HOUR_OPTIONS = Array.from({ length: 12 }, (_, i) => ({
  value: (i + 1).toString(),
  label: (i + 1).toString(),
}));

// Generate minute options (00-59)
export const MINUTE_OPTIONS = Array.from({ length: 60 }, (_, i) => ({
  value: i.toString().padStart(2, "0"),
  label: i.toString().padStart(2, "0"),
}));

// Period options for 12-hour time format
export const PERIOD_OPTIONS = [
  {
    value: "AM",
    text: "AM",
  },
  {
    value: "PM",
    text: "PM",
  },
];

// Default values for incomplete time selections
export const DEFAULT_VALUES = {
  HOUR: 1,
  MINUTE: 0,
  PERIOD: "AM",
};
